<template>
	<div class="mc-switch"
	     role="switch"
	     :class="{'is-disabled': disabled}"
	     @click="switchValue"
	>
		<input type="checkbox"
		       ref="input"
		       @change="switchValue"
		       :disabled="disabled"
		       class="mc-switch__input">
		<span class="mc-switch__core" @click="switchValue" :class="{'is-active': !!value}" :style="{width: coreWidth + 'px'}">
			<span class="mc-switch__button" :style="{ transform }"></span>
		</span>
	</div>
</template>
<script type="text/ecmascript-6">
    export default {
        name: 'base-switch',
        props: {
	        disabled: {
                type: Boolean,
		        default: false
	        },
	        name: {
                type: [String, Number]
	        },
            value: {
                type: [Boolean, String, Number],
	            default: false
            },
	        width: {
                type: Number,
		        default: 30
	        }
        },
	    data: function () {
		    return {
                coreWidth: this.width
		    }
        },
	    computed: {
            checked: function () {
	            return !!this.value;
            },
            transform: function () {
                return this.checked ? `translate3d(${ this.coreWidth - 18 }px, 0, 0)` : '';
            }
	    },
	    watch: {
            checked: function () {
                this.$refs.input.checked = this.checked;
            }
	    },
	    methods: {
            handleChange: function () {
                this.$emit('input', !this.checked);
                this.$emit('change', !this.checked);
                this.$nextTick(() => {
                    this.$refs.input.checked = this.checked;
                });
            },
            switchValue: function () {
                !this.disabled && this.handleChange();
            }
        },
	    mounted: function () {
            this.$refs.input.checked = this.checked;
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/base-switch.vue